module.exports = __webpack_public_path__ + "img/au_gallery_5.533c51fb.jpg";